export default __webpack_public_path__ + "static/media/progress.9ce1acfc.less";